/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `fyzickaOsoba` - Fyzická
 *   * `pravnickaOsoba` - Právnická
 * ```
 */
export const TypOsobyEnum = {
  fyzickaOsoba: 'fyzickaOsoba',
  pravnickaOsoba: 'pravnickaOsoba',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TypOsobyEnum = ValuesOf<typeof TypOsobyEnum>;

export type TypOsobyEnumRequest = TypOsobyEnum;
export type TypOsobyEnumResponse = TypOsobyEnum;
